import axios from "axios";

const publicApi = axios.create({
  baseURL:
    process.env.REACT_APP_API_URL ||
    "https://collings-be-5febdc804269.herokuapp.com",
  headers: {
    "Content-Type": "application/json",
    // "ngrok-skip-browser-warning": "true", 
  },
});

publicApi.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("Public API Error:", error);
    return Promise.reject(error);
  }
);

export default publicApi;

export const getPublicProperties = (params = {}) =>
  publicApi.get("public-search/properties/", { params });

export const getPublicPropertyById = (id) =>
  publicApi.get(`public-search/properties/${id}/`);

export const submitContactForm = (formData) =>
  publicApi.post("api/chatbot/submit-form/", formData);

export const startChatbotSession = (data) =>
  publicApi.post("api/chatbot/start/", data);

export const searchPublicProperties = (query) =>
  publicApi.get("public-search/properties/", {
    params: { search: query }
  });

export const filterPublicProperties = (filters) =>
  publicApi.get("public-search/properties/", { params: filters });

// Additional owner management (requires authentication)
export const addAdditionalOwner = async (propertyId, ownerData) => {
  const api = (await import('./index')).default;
  const numericId = propertyId.toString().replace('crm-', '');
  return api.post(`property-management/properties/${numericId}/additional-owners/`, ownerData);
};

export const deleteAdditionalOwner = async (propertyId, ownerId) => {
  const api = (await import('./index')).default;
  const numericId = propertyId.toString().replace('crm-', '');
  return api.delete(`property-management/properties/${numericId}/additional-owners/${ownerId}/`);
};

// Patch public property (for archive/unarchive - requires authentication)
export const patchPublicProperty = async (id, data) => {
  // Import authenticated API client
  const api = (await import('./index')).default;

  // Extract numeric ID if prefixed with 'crm-'
  const numericId = id.toString().replace('crm-', '');

  // Convert to FormData for compatibility with backend
  const formData = new FormData();
  Object.keys(data).forEach(key => {
    const value = data[key];
    if (typeof value === 'boolean') {
      formData.append(key, value ? 'true' : 'false');
    } else if (value !== null && value !== undefined) {
      formData.append(key, value);
    }
  });

  return api.put(`property-management/properties/${numericId}/`, formData, {
    headers: { "Content-Type": "multipart/form-data" }
  });
};

